import { useField } from "formik";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const TextInput = ({ label, errorMsg, ...props }) => {
  const [field, meta] = useField(props);

  return (
    <>
      <Form.Group className="mb-3" as={Col} md="12">
        <Form.Label className="form-text" htmlFor={props.id || props.name}>
          {label}
        </Form.Label>
        <Form.Control
          {...field}
          {...props}
          isInvalid={(meta.touched && meta.error) || errorMsg}
        />

        <Form.Control.Feedback type="invalid" tooltip>
          {meta.touched && meta.error ? (
            <div className="error">{meta.error}</div>
          ) : null}
          {errorMsg && errorMsg}
        </Form.Control.Feedback>
      </Form.Group>
    </>
  );
};

export default TextInput;
